/**
 * ACTION PHOTO DOCUMENT DATA SOURCE CHANGE INIT
 * Reset change data source photo document
 */
export const annotationPhotoDocumentDataSourceChangeInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT DATA SOURCE CHANGE
 * Change data source photo document
 * @param {object} data - data id, dataSourceId
 */
export const annotationPhotoDocumentDataSourceChange = ({
  id,
  dataSourceId,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      id !== undefined &&
      dataSourceId !== undefined
    ) {
      dispatch({
        type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        data_source_id: dataSourceId,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS DATA SOURCE CHANGE INIT
 * Reset change data source photo document
 */
export const annotationPhotoDocumentsDataSourceChangeInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS DATA SOURCE CHANGE
 * Change data source photo document
 * @param {object} data - data ids, dataSourceId
 */
export const annotationPhotoDocumentsDataSourceChange = ({
  ids,
  dataSourceId,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      ids !== undefined &&
      dataSourceId !== undefined
    ) {
      dispatch({
        type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        data_source_id: dataSourceId,
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_PHOTO_DOCUMENT_DATA_SOURCE_CHANGE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};
